import { useState } from "react";
import Icon from "../icon/icons";
import ErrorBoundary from "../errorboundary/errorboundary";

const BTN_RADIUS = {
  pill: "rounded-full",
  sm: "rounded-sm",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  none: "rounded-none",
};

export default function AuthGeneralInput({
  label,
  labelClass,
  radius = "md",
  type = "text",
  readOnly,
  name,
  placeholder,
  value,
  inputClass,
  change,
  notrequired,
  description,
  error,
}) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <ErrorBoundary>
      {type === "password" ? (
        <>
          <div
            className="form-icon form-icon-right passcode-switch lg"
            onClick={() => setShowPassword((prv) => !prv)}
          >
            
          </div>
          {label && (
            <label
              className={`w-full block text-xs md:text-sm mb-2 text-black dark:text-white ${labelClass}`}
            >
              {label}
            </label>
          )}
          <div className="relative w-full overflow-hidden">
          <input
            type={showPassword ? "text" : type}
            name={name}
            className={`w-full border border-grey-100 bg-white px-4 py-3 text-sm md:text-base placeholder:text-grey-50 outline-none
            ${BTN_RADIUS[radius] || BTN_RADIUS.sm} ${inputClass || ""}`}
            placeholder={placeholder}
            value={value}
            readOnly={readOnly}
            onChange={change}
            required={!notrequired}
          />
          <div className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer" onClick={() => setShowPassword((prv) => !prv)}>
          <Icon name={showPassword ? "eye-off" : "eye"} iconClass="w-5 text-grey-400" />
          
          </div>
          </div>
        </>
      ) : (
        <>
          {label && (
            <label
              htmlFor={name}
              className={`w-full block text-xs md:text-sm mb-2 text-black dark:text-white ${labelClass}`}
            >
              {label} {!notrequired && <span className="text-red-500">*</span>}
            </label>
          )}
          {description && (
            <p className="text-xs text-grey-dark mb-2">{description}</p>
          )}

          <div className="group relative w-full overflow-hidden">
            <input
              id={name}
              type={type}
              name={name}
              className={`w-full border ${error ? 'border-red-500' : 'border-grey-200'} bg-white px-4 py-3 text-sm md:text-base placeholder:text-grey-50 outline-none
              ${BTN_RADIUS[radius] || BTN_RADIUS.sm} ${inputClass || ""}
              `}
              placeholder={placeholder}
              value={value}
              readOnly={readOnly}
              onChange={change}
              required={!notrequired}
              aria-label={label || placeholder}
            />
          </div>
          {error && (
            <p className="text-xs text-red-500 mt-1">{error}</p>
          )}

            {/* search icon for search inputs */}
            {type === "search" && !value && (
              <div className="absolute top-1/2 -translate-y-1/2 left-3 truncate md:text-xs pointer-events-none">
                <Icon name="search" iconClass="w-5 text-grey-400" />
              </div>
            )}
          
        </>
      )}
    </ErrorBoundary>
  );
}